<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :config-module="configModule"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :export-file-name="priceUtil.getFileName(fileName)"
          :row-data="rowData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'

export default {
  name: 'PolChargeDataGrid',
  components: {},
  props: {
    configModule: { type: String, default: '224100' },
    showCostOrSell: { type: Boolean, default: false },
    showCost: { type: Boolean, default: false },
    showApprove: { type: Boolean, default: false },
    showModify: { type: Boolean, default: false },
    showBranch: { type: Boolean, default: false },
    showCreate: { type: Boolean, default: false },
    fileName: { type: String, default: 'PODCharge' },
    showHistory: { type: Boolean, default: false },
    showBasicInfo: { type: Boolean, default: true },
    showSelection: { type: Boolean, default: true },
    gridOptions: { type: Object, default: () => {} },
    rowData: { type: Array, default: () => [] }
  },
  data() {
    return {
      showLevel: false, // 是否显示运价等级
      txtRemarks: '',
      remarkChange: false,
      authedLevel: 99,
      priceUtil: PriceUtils,
      proxy: {},
      filterJson: {},
      showDetail: false,
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: ' ', maxWidth: 40, checkboxSelection: true,
          hide: !this.showSelection, suppressColumnsToolPanel: !this.showSelection,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Pricing.Source'), field: 'bookingAgent', colId: 'bookingAgent', width: 200,
          hide: !this.showBasicInfo,
          cellRenderer: (params) => {
            return ColumnUtils.companyShortNameLabelFun(params.value)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          } },
        {
          headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', width: 200,
          hide: !this.showBasicInfo,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        }, { headerName: this.$t('Pricing.POD'), field: 'pod', colId: 'pod', width: 200,
          hide: !this.showBasicInfo,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          } },
        { headerName: this.$t('Pricing.TradeLane'), field: 'tradeLane', colId: 'tradeLane', width: 200,
          hide: !this.showBasicInfo,
          cellRenderer: (params) => {
            return PriceUtils.getRegionName(params.value)
          } },
        {
          headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.companyShortNameLabelFun(params.value)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          colId: 'feeIndex',
          field: 'feeIndex',
          headerName: this.$t('Pricing.FeeIndex'),
          hide: !this.showBasicInfo
        },
        {
          headerName: this.$t('Pricing.ChargeType'), field: 'chargeType', colId: 'chargeType', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.chargeTypeLabelFunc(params)
          }
        },
        {
          headerName: this.$t('Pricing.FeeName'), field: 'chargeScaleCode', colId: 'chargeScaleCode', width: 200,
          valueFormatter: (params) => {
            return params.value
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'scaleCode', params.value, 'zhName')
          }
        },
        {
          headerName: this.$t('Pricing.ChargeUnit'), field: 'unit', colId: 'unit', width: 200,
          cellRenderer: (params) => {
            let unit = CommonState.getNameByCode(ChargeMeasure.CHARGE_MEASURES, params.value)
            if (!unit) {
              unit = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
            }
            return unit
          }
        },
        {
          headerName: this.$t('Pricing.Currency'), field: 'currency', colId: 'currency', width: 200
        },
        {
          headerName: this.$t('Pricing.VatIncluded'), field: 'isVat', colId: 'isVat', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        {
          colId: 'coloaderMin',
          field: 'coloaderMin',
          headerName: this.$t('Pricing.ColoaderMin'),
          cellRenderer: (params) => {
            return this.numberColumnLabelFunc(params)
          }
        },
        {
          colId: 'coloaderRate',
          field: 'coloaderRate',
          headerName: this.$t('Pricing.ColoaderRate'),
          cellRenderer: (params) => {
            return this.numberColumnLabelFunc(params)
          }
        },
        {
          colId: 'customerMin',
          field: 'customerMin',
          headerName: this.$t('Pricing.CustomerMin'),
          cellRenderer: (params) => {
            return this.numberColumnLabelFunc(params)
          }
        },
        {
          colId: 'customerRate',
          field: 'customerRate',
          headerName: this.$t('Pricing.CustomerRate'),
          cellRenderer: (params) => {
            return this.numberColumnLabelFunc(params)
          }
        },
        {
          headerName: this.$t('Pricing.COST_VAT'), field: 'costVat', colId: 'costVat', width: 200,
          hide: (this.showCostOrSell || !this.showCost), suppressColumnsToolPanel: (this.showCostOrSell || !this.showCost)
        },
        {
          headerName: this.$t('Pricing.SELL_VAT'), field: 'sellVat', colId: 'sellVat', width: 200,
          hide: (this.showCostOrSell || !this.showCost), suppressColumnsToolPanel: (this.showCostOrSell || !this.showCost)
        },
        {
          headerName: this.$t('Pricing.VAT'), field: 'sellVat', colId: 'sellVat', width: 200,
          hide: !this.showCostOrSell, suppressColumnsToolPanel: !this.showCostOrSell,
          cellRenderer: (params) => {
            return PriceUtils.vatLabelFunc2(params)
          }
        },
        { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.Branch'), field: 'branchId', colId: 'branchId', width: 200,
          hide: !(this.showCreate && this.showBranch), suppressColumnsToolPanel: !(this.showCreate && this.showBranch),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
          } },
        { headerName: this.$t('Pricing.CreatedBy'), field: 'createdBy', colId: 'createdBy', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.CreatedDate'), field: 'dateCreated', colId: 'dateCreated', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ModifiedBy'), field: 'modifiedBy', colId: 'modifiedBy', width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.ModifiedDate'), field: 'dateModified', colId: 'dateModified', width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ApprovedBy'), field: 'approvedBy', colId: 'approvedBy', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.ApprovedDate'), field: 'dateApproved', colId: 'dateApproved', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.EffectiveDate'), field: 'dateEffective', colId: 'dateEffective', width: 200,
          hide: !this.showHistory, suppressColumnsToolPanel: !this.showHistory,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ExpirationDate'), field: 'dateExpiration', colId: 'dateExpiration', width: 200,
          hide: !this.showHistory, suppressColumnsToolPanel: !this.showHistory,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          } }
      ]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    }
  },
  methods: {
    numberColumnLabelFunc(params) {
      if (params.value === 0.0) {
        return 0
      }
      return PriceUtils.priceByViewColumnLabelFunc_nolimit(params, null)
    }
  }
}
</script>
<style lang="scss">
</style>

